import React, { useEffect, useState } from 'react'
import ModalCustom from '../../modal-custom'
import { Button, Col, Form, Row } from 'react-bootstrap'
import LabelCustom from '../../label-custom'
import { Controller, useForm } from 'react-hook-form'
import { Select } from 'antd'
import PickerRangeCustom from '../../datepicker-between-custom'
import DatepickerCustom from '../../datepicker-custom'
import moment from 'moment'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import UsePosition from '../../../hooks/use-certificate-type-certificate'
import UseTypeCourse from '../../../hooks/use-certificate-type-course'
import UseTestPass from '../../../hooks/use-certificate-test'
import UseLevel from '../../../hooks/use-certificate-level'
import UseBrand from '../../../hooks/use-certificate-brand'
import UseExpire from '../../../hooks/use-certificate-expire-certificate'
import UseExpied from '../../../hooks/use-certificate-course-fee'
import UseStatusActive from '../../../hooks/use-certificate-course-fee copy'
import {
  deleteTrainingsAPI,
  updateTrainingAPI
} from '../../../services/certificate'
import SwalCustom from '../../../alert/swal-custom'
import Error_false from '../../error/error-false'
import { TXTSUCCESS } from '../../../Constants'
import Error_500 from '../../error/error-500'

function ModaleditCertificate({
  onEdit,
  handleClose,
  data,
  fnData,
  code,
  orgId,
  isSave,
  setIsSave
}) {
  const schema = yup
    .object({
      typeOfCourse: yup.string().required('Please, Choose Type of Course'),
      typeOfCertificate: yup
        .string()
        .required('Please, Choose Type of Certificate'),
      date: yup.array().required('Please, Choose Periods '),
      course: yup.string().required('Please, Choose Course Name'),
      typeOfProduct: yup
        .string()
        .required('Please, Fill Type of Product (Tag)'),
      expStatus: yup.string().required('Please, Choose Course Fee'),
      brand: yup.string().required('Please, Choose Partner Name'),
      level: yup.string().required('Please, Choose Level'),
      statusActive: yup.string().required('Please, Choose Status'),
      expireDate: yup.string().required('Please, Choose Expire Status'),
      statusH: yup.string().required('Please, Choose Status'),
      exStatusId: yup.string().required('Please, Choose Status')
    })
    .required()
  const {
    control,
    setValue,
    setError,
    handleSubmit,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema)
  })

  const typeExpiedYN = UseExpied()
  const typeExpense = UseExpire()
  const typeBrand = UseBrand()
  const typeLevel = UseLevel()
  const typeTestPass = UseTestPass()
  const typeCourse = UseTypeCourse()
  const typeCertificate = UsePosition()
  const typeActive = UseStatusActive()

  const [course, setCourse] = useState()
  const [hourCourse, setHourCourse] = useState()
  const [brand, setBrand] = useState()
  const [certificate, setCertificate] = useState()
  const [level, setLevel] = useState()
  const [courseName, setCourseName] = useState()
  const [status, setStatus] = useState()
  const [statusExID, setStatusExID] = useState()
  const [expireDate, setExpireDate] = useState()
  const [startDate, setStartDate] = useState()
  const [endDate, setEndDate] = useState()
  const [certificateNo, setCertificateNo] = useState()
  const [tag, setTag] = useState()
  const [courseFees, setCourseFees] = useState()
  const [expStatus, setExpStatus] = useState()
  const [active, setActive] = useState(1)
  useEffect(() => {
    setValue('typeOfCourse', data?.course ?? '')
    setError('typeOfCourse', false)

    setValue('typeOfCertificate', data?.t_position ?? '')
    setError('typeOfCertificate', false)

    setValue('date', [`${data?.start_date}`, `${data?.end_date}`] ?? '')
    setError('date', false)

    setValue('course', data?.course_name ?? '')
    setError('course', false)

    setValue('typeOfProduct', data?.product ?? '')
    setError('typeOfProduct', false)

    setValue('courseFee', data?.course_fee ?? '')
    setError('courseFee', false)

    setValue('expStatus', data?.exp_status_id ?? '')
    setError('expStatus', false)

    setValue('brand', data?.partner_name ?? '')
    setError('brand', false)

    setValue('level', data?.t_level ?? '')
    setError('level', false)

    setValue('certificateNo', data?.certificate_no ?? '')
    setError('certificateNo', false)

    setValue('statusActive', data?.t_status_id ?? 1)
    setError('statusActive', false)

    setValue('expireDate', data?.expire ?? '')
    setError('expireDate', false)

    setValue('statusH', data?.status ?? '')
    setError('statusH', false)

    setValue('expireDates', data.expire_date ? data.expire_date : '')
    setError('expireDates', false)

    setValue('hour', data?.hour ?? '')
    setError('hour', false)

    setValue('exStatusId', data?.exp_status ?? '')
    setError('exStatusId', false)
  }, [onEdit, setError, setValue])

  const onSubmit = () => {
    setIsSave(true)
    const body = {
      tnId: data.id,
      orgId,
      code,
      courseId: course ?? data.course_id ?? '', //coureId
      hour: hourCourse ?? data.hour ?? data.hour ?? '', //hourCourse
      partnerName: brand ?? data.partner_name ?? '', //brandName
      tPositionId: certificate ?? data.t_position_id ?? '', //typeOfCerttificate
      tLevelId: level ?? data.t_level_id ?? '', //level
      courseName: courseName ?? data.course_name ?? '', //courseName
      startDate:
        startDate ?? moment(data.start_date).format('YYYY-MM-DD') ?? '',
      endDate: endDate ?? moment(data.end_date).format('YYYY-MM-DD') ?? '',
      statusId: status ?? data.status_id ?? '', //testStatus
      certificateNo: certificateNo ?? data.certificate_no ?? '', //cerNo
      expireId: statusExID ?? data.expire_id ?? '', //มีวันหมกอายุไหม
      expireDate:
        expireDate ??
        moment(expireDate).format('YYYY-MM-DD') ??
        moment(data.expire_date).format('YYYY-MM-DD') ??
        '', //วันหมกอายุ
      expStatusId: expStatus ?? data.exp_status_id ?? '', //มีค่าใช้จ่ายไหม
      tStatusId: active ?? data.t_status_id ?? '', //ในเส้น get คืออันไหน //active
      courseFee: courseFees ?? data.course_fee ?? data.course_fee ?? '', //amountFee
      product: tag ?? data.product ?? '' //tag
    }
    updateTraining(body)
  }
  const updateTraining = async (body) => {
    const data = await updateTrainingAPI(body)
    setIsSave(false)

    if (data?.status) {
      SwalCustom({
        title: 'Success!',
        text: 'Your work has been saved',
        timer: 1500,
        showConfirmButton: false
      }).then(() => {
        fnData({ orgId, code })
        handleClose()
      })
    } else {
      Error_false(data)
    }
  }

  const fnDelete = () => {
    const body = {
      orgId,
      code,
      tnId: data.id
    }
    SwalCustom({
      title: 'Are you sure?',
      text: 'Do you want to delete this?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        setIsSave(true)
        deleteTraining(body)
      }
    })
  }

  const deleteTraining = async (body) => {
    try {
      const res = await deleteTrainingsAPI(body)
      if (res.status) {
        SwalCustom({
          title: `Success!`,
          text: TXTSUCCESS,
          timer: 1500,
          showConfirmButton: false
        }).then(() => {
          setIsSave(false)
          handleClose()
          fnData({ orgId, code })
        })
      } else {
        setIsSave(false)
        Error_false(res)
      }
      setIsSave(false)
    } catch (error) {
      Error_500(error)
      setIsSave(false)
    }
  }

  return (
    <ModalCustom width={800} open={onEdit} onCancel={handleClose}>
      <Form
        onSubmit={handleSubmit(onSubmit)}
        className="mt-3 row"
        style={{ rowGap: '13px' }}
      >
        <Row style={{ rowGap: '15px' }}>
          <Col md={6}>
            <Col md={12} className="mt-2">
              <LabelCustom text={'Doc No.'} />{' '}
              <Controller
                name={'docNo'}
                control={control}
                render={({ field: { onChange, value = '' } }) => (
                  <Form.Control
                    className="w-100 mt-2"
                    disabled
                    value={`${data?.doc_no.toUpperCase()}`}
                    onChange={onChange}
                  />
                )}
              />
              {errors.course?.message && (
                <label className="small text-danger">
                  {errors.course.message}
                </label>
              )}
            </Col>

            <Col md={12} className="mt-2">
              <LabelCustom text={'Type of Course'} />{' '}
              <Controller
                name={'typeOfCourse'}
                control={control}
                render={({ field: { onChange, value = '' } }) => (
                  <>
                    {value == 3 ||
                    (value === 'Online Learning' && data?.course_id === 3) ||
                    (data?.course_id === 3 && value == 3) ||
                    value === 'Online Learning' ? (
                      <>
                        <div className="col-12 d-flex gap-2">
                          <div className="col-6">
                            <Select
                              className="w-100 mt-2"
                              options={typeCourse}
                              value={value}
                              onChange={(value) => {
                                onChange(value)
                                setCourse(value)
                              }}
                            />
                          </div>
                          <div className="col-6 mt-2">
                            <Controller
                              name={'hour'}
                              control={control}
                              render={({ field: { onChange, value = '' } }) => (
                                <Form.Control
                                  className="w-100"
                                  placeholder="Hours*"
                                  value={value}
                                  onChange={(e) => {
                                    onChange(e.target.value)
                                    setHourCourse(e.target.value)
                                  }}
                                />
                              )}
                            />
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        {' '}
                        <Select
                          className="w-100 mt-2"
                          options={typeCourse}
                          value={value}
                          onChange={(value) => {
                            onChange(value)
                            setCourse(value)
                          }}
                        />
                      </>
                    )}
                  </>
                )}
              />
              {errors.typeOfCourse?.message && (
                <label className="small text-danger">
                  {errors.typeOfCourse.message}
                </label>
              )}
            </Col>

            <Col md={12} className="mt-2">
              <LabelCustom text={'Type of Certificate'} />{' '}
              <Controller
                name={'typeOfCertificate'}
                control={control}
                render={({ field: { onChange, value = '' } }) => (
                  <Select
                    className="w-100 mt-2"
                    options={typeCertificate}
                    value={value}
                    onChange={(value) => {
                      onChange(value)
                      setCertificate(value)
                    }}
                  />
                )}
              />
              {errors.typeOfCertificate?.message && (
                <label className="small text-danger">
                  {errors.typeOfCertificate.message}
                </label>
              )}
            </Col>

            <Col md={12} className="mt-2">
              <LabelCustom text={'Course/ Exam Name'} />{' '}
              <Controller
                name={'course'}
                control={control}
                render={({ field: { onChange, value = '' } }) => (
                  <Form.Control
                    className="w-100 mt-2"
                    value={value}
                    onChange={(e) => {
                      onChange(e)
                      setCourseName(e.target.value)
                    }}
                  />
                )}
              />
              {errors.course?.message && (
                <label className="small text-danger">
                  {errors.course.message}
                </label>
              )}
            </Col>

            <Col md={12} className="mt-2">
              <LabelCustom text={'Periods'} />{' '}
              <Controller
                name={'date'}
                control={control}
                render={({ field: { onChange, value = '' } }) => (
                  <>
                    <PickerRangeCustom
                      value={value}
                      onChange={(date) => {
                        if (date.length > 1) {
                          const st = `${moment(date[0]).format('YYYY-MM-DD')}`
                          const en = `${moment(date[1]).format('YYYY-MM-DD')}`
                          setValue('date', [st, en])
                          setStartDate(st)
                          setEndDate(en)
                        } else if (date.length === 0) {
                          setValue('date', ['', ''])
                        }
                      }}
                    />
                  </>
                )}
              />
              {errors.date?.message && (
                <label className="small text-danger">
                  {errors.date.message}
                </label>
              )}
            </Col>

            <Col md={12} className="mt-2">
              <LabelCustom text={'Type of Product (Tag)'} />{' '}
              <Controller
                name={'typeOfProduct'}
                control={control}
                render={({ field: { onChange, value = '' } }) => (
                  <Form.Control
                    className="w-100 mt-2"
                    value={value}
                    onChange={(e) => {
                      onChange(e)
                      setTag(e.target.value)
                    }}
                  />
                )}
              />
              {errors.typeOfProduct?.message && (
                <label className="small text-danger">
                  {errors.typeOfProduct.message}
                </label>
              )}
            </Col>

            <Col md={12} className="mt-2">
              <LabelCustom text={'Course Fee'} />{' '}
              <Controller
                name={'expStatus'}
                control={control}
                render={({ field: { onChange, value = '' } }) => (
                  <>
                    {(value == 2 && data?.exp_status_id === 2) || value == 2 ? (
                      <>
                        <div className="col-12 d-flex gap-2 mt-2">
                          <div className="col-6">
                            <Select
                              className="w-100"
                              options={typeExpense}
                              value={value}
                              onChange={(value) => {
                                onChange(value)
                                setExpStatus(value)
                              }}
                            />
                          </div>
                          <Controller
                            name={'courseFee'}
                            control={control}
                            render={({ field: { onChange, value = '' } }) => (
                              <div className="col-6 ">
                                <Form.Control
                                  className="w-100 "
                                  placeholder="Amount*"
                                  value={value}
                                  onChange={(e) => {
                                    onChange(e.target.value)
                                    setCourseFees(e.target.value)
                                  }}
                                />
                              </div>
                            )}
                          />
                        </div>
                      </>
                    ) : (
                      <>
                        <Select
                          className="w-100 mt-2"
                          options={typeExpense}
                          value={value}
                          onChange={(value) => {
                            onChange(value)
                            setExpStatus(value)
                          }}
                        />
                      </>
                    )}
                  </>
                )}
              />
              {errors.expStatus?.message && (
                <label className="small text-danger">
                  {errors.expStatus.message}
                </label>
              )}
            </Col>
          </Col>

          <Col md={6}>
            <Col md={12} className="mt-2">
              <LabelCustom text={'Brand/ Partner'} />{' '}
              <Controller
                name={'brand'}
                control={control}
                render={({ field: { onChange, value = '' } }) => (
                  <Select
                    options={typeBrand}
                    className="w-100 mt-2"
                    value={value}
                    onChange={(value) => {
                      onChange(value)
                      setBrand(value)
                    }}
                  />
                )}
              />
              {errors.brand?.message && (
                <label className="small text-danger">
                  {errors.brand.message}
                </label>
              )}
            </Col>

            <Col md={12} className="mt-2">
              <LabelCustom text={'Level'} />{' '}
              <Controller
                name={'level'}
                control={control}
                render={({ field: { onChange, value = '' } }) => (
                  <Select
                    className="w-100 mt-2"
                    options={typeLevel}
                    value={value}
                    onChange={(value) => {
                      onChange(value)
                      setLevel(value)
                    }}
                  />
                )}
              />
              {errors.level?.message && (
                <label className="small text-danger">
                  {errors.level.message}
                </label>
              )}
            </Col>

            <Col md={12} className="mt-2">
              <LabelCustom text={'Status'} />{' '}
              <Controller
                name={'statusH'}
                control={control}
                render={({ field: { onChange, value = '' } }) => (
                  <Select
                    options={typeTestPass}
                    className="w-100 mt-2"
                    value={value}
                    onChange={(value) => {
                      onChange(value)
                      setStatus(value)
                    }}
                  />
                )}
              />
              {errors.statusH?.message && (
                <label className="small text-danger">
                  {errors.statusH.message}
                </label>
              )}
            </Col>

            <Col md={12} className="">
              <LabelCustom text={'Certificate No.'} />{' '}
              <Controller
                name={'certificateNo'}
                control={control}
                render={({ field: { onChange, value = '' } }) => (
                  <Form.Control
                    className="w-100 mt-2"
                    value={value}
                    onChange={(e) => {
                      onChange(e.target.value)
                      setCertificateNo(e.target.value)
                    }}
                  />
                )}
              />
              {errors.certificateNo?.message && (
                <label className="small text-danger">
                  {errors.certificateNo.message}
                </label>
              )}
            </Col>

            <Col md={12} className="mt-3">
              <LabelCustom text={'Expire Date of Certificate'} />{' '}
              <Controller
                name={'expireDate'}
                control={control}
                render={({ field: { onChange, value = '' } }) => (
                  <>
                    {value === 'มี' ||
                    (value == 2 && data?.expire_id === 1) ||
                    (data?.expire_id === 2 && value == 2) ||
                    value === 'มี' ? (
                      <>
                        <div className="col-12 d-flex gap-2 ">
                          <div className="col-6">
                            <Select
                              className="w-100"
                              options={typeExpiedYN}
                              value={value}
                              onChange={(value) => {
                                onChange(value)
                                setStatusExID(value) // expireDate
                              }}
                            />
                          </div>
                          <Controller
                            name={'expireDates'}
                            control={control}
                            render={({ field: { onChange, value = '' } }) => (
                              <div className="col-6 ">
                                <DatepickerCustom
                                  className="w-100 mt-2"
                                  value={value}
                                  isClearable
                                  onChange={([date]) => {
                                    setValue(
                                      'expireDates',
                                      `${
                                        date
                                          ? moment(date).format('YYYY-MM-DD')
                                          : ''
                                      }`
                                    )
                                    setExpireDate(
                                      date
                                        ? moment(date).format('YYYY-MM-DD')
                                        : ''
                                    )
                                    setError('expireDates', false)
                                  }}
                                />
                              </div>
                            )}
                          />
                        </div>
                      </>
                    ) : value == 1 && data.expire_id === 2 ? (
                      <>
                        <Select
                          className="w-100 "
                          options={typeExpiedYN}
                          value={value}
                          onChange={(value) => {
                            onChange(value)
                            setStatusExID(value) // expireDate
                          }}
                        />
                      </>
                    ) : data.expire_id === 1 ? (
                      <>
                        <Select
                          className="w-100 "
                          options={typeExpiedYN}
                          value={value}
                          onChange={(value) => {
                            onChange(value)
                            setStatusExID(value) // expireDate
                          }}
                        />
                      </>
                    ) : null}
                  </>
                )}
              />
              {errors.expireDate?.message && (
                <label className="small text-danger">
                  {errors.expireDate.message}
                </label>
              )}
            </Col>

            <Col md={12} className="mt-2">
              <LabelCustom text={'Active'} />{' '}
              <Controller
                name={'statusActive'}
                control={control}
                render={({ field: { onChange, value = '' } }) => (
                  <>
                    <Select
                      className="w-100 mt-2 "
                      options={typeActive}
                      value={value}
                      onChange={(value) => {
                        onChange(value)
                        setActive(value)
                      }}
                    />
                  </>
                )}
              />
              {errors.statusActive?.message && (
                <label className="small text-danger">
                  {errors.statusActive.message}
                </label>
              )}
            </Col>
          </Col>

          <Col xl={12} className="text-center mt-3">
            <Button
              className="px-4 me-2 boeder-0"
              size="sm"
              variant="danger"
              type="button"
              disabled={isSave}
              onClick={fnDelete}
            >
              Delete
            </Button>
            <Button
              variant="light"
              className="px-4 text-primary me-2"
              size="sm"
              onClick={handleClose}
            >
              Close
            </Button>
            <Button type="submit" className="px-4" size="sm">
              {isSave ? 'Saving......' : 'Save'}
            </Button>
          </Col>
        </Row>
      </Form>
    </ModalCustom>
  )
}

export default ModaleditCertificate
